// extracted by mini-css-extract-plugin
module.exports = {"comment-head":"comment-head___1EvO7","comment-body":"comment-body___3r-dh"};